import { Injectable, inject } from '@angular/core';
import { CollectionReference, DocumentData, Firestore, collection, collectionData, orderBy, query } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MessageService<ENTITY> {

  private _collectionRef: CollectionReference<DocumentData>;
  private _firestore: Firestore = inject(Firestore);

  constructor() {
    this._collectionRef = collection(this._firestore, 'message-dev');
  }

  public list(): Observable<ENTITY []> {
    const itemsQuery = query(this._collectionRef, orderBy('priority'));

    return collectionData(itemsQuery, { idField: 'id' }) as Observable<ENTITY[]>;
  }

  public listFiltered(attr: string, value: any, operator: string): Observable<ENTITY[]> {
    return this.list().pipe(
      map(items => items.filter((item: any) => this.evaluateCondition(item[attr], value, operator))),
      map(items => items.filter((item: any) => item.available === true))
    );
  }

  private evaluateCondition(itemValue: any, value: any, operator: string): boolean {
    switch (operator) {
      case '==': return itemValue === value;
      case '!=': return itemValue !== value;
      case '<': return itemValue < value;
      case '<=': return itemValue <= value;
      case '>': return itemValue > value;
      case '>=': return itemValue >= value;
      
      default: throw new Error(`Operator ${operator} is not supported`);
    }
  }
}
